/**
 * default provided account colors
 */
export enum AccountColor {
  None = "none",
  Pink = "pink",
  Purple = "purple",
  Blue = "blue",
  LightBlue = "lightBlue",
  Teal = "teal",
  Green = "green",
  Yellow = "yellow",
  Orange = "orange",
  Red = "red",
}

export interface AccountColorConfig {
  /**
   * base hexcode color
   */
  base: string;
  /**
   * accent hexcode color
   */
  accent: string;
}
